import { SearchPill } from 'src/UI/generate-flow/SearchPill';
import { Button } from 'src/design-system/Button';

type SearchbarActionButtonProps = {
  searchOpen: boolean;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  buttonLabel: string;
  onButtonClick: () => void;
};

export function SearchbarActionButton({
  searchOpen,
  value,
  onChange,
  placeholder,
  buttonLabel,
  onButtonClick,
}: SearchbarActionButtonProps) {
  if (searchOpen) {
    return <SearchPill value={value} onChange={onChange} placeholder={placeholder} />;
  }

  return (
    <Button variant="secondary" onClick={onButtonClick}>
      {buttonLabel}
    </Button>
  );
}
